import { render, staticRenderFns } from "./OrderCommentCreate.vue?vue&type=template&id=77499327&"
import script from "./OrderCommentCreate.vue?vue&type=script&lang=ts&"
export * from "./OrderCommentCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports